import * as React from "react";
const IconPen = (props) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.0417 3.93711C19.9533 2.84876 18.1888 2.84876 17.1004 3.93712L15.6953 5.34223L19.6366 9.28351L21.0417 7.87839C22.13 6.79003 22.13 5.02547 21.0417 3.93711ZM18.5759 10.3442L14.6346 6.40289L5.6449 15.3926C5.08436 15.9532 4.70535 16.6693 4.5571 17.4481L4.13289 19.6765C4.00093 20.3697 4.60906 20.9779 5.30225 20.8459L7.53072 20.4217C8.30947 20.2734 9.02563 19.8944 9.58618 19.3339L18.5759 10.3442Z"
      fill="#1C1C2C"
    />
  </svg>
);
export default IconPen;
